import { Modify } from 'ol/interaction';

export default {
  methods: {
    resetModifyZones() {
      this.map.removeInteraction(this.getInteractionByName('zonesCalculatorModify'));
    },
    handleModifyZones(callback = () => {}) {
      const zonesLayer = this.getLayerById('zones-calculator');
      if (!zonesLayer) throw Error(`Layer zones-calculator doesn't exist`);
      const modifyInteraction = new Modify({
        source: zonesLayer.getSource(),
      });
      modifyInteraction.on('modifyend', e => callback(e, zonesLayer));
      modifyInteraction.set('name', 'zonesCalculatorModify');
      this.map.addInteraction(modifyInteraction);
    },
  },
  created() {
    this.$root.$off('handleModifyZones');
    this.$root.$on('handleModifyZones', this.handleModifyZones);
    this.$root.$off('resetHandleModifyZones');
    this.$root.$on('resetHandleModifyZones', this.resetModifyZones);
  },
};
